<script setup lang="ts">
import DirectusImage from './DirectusImage.vue';

const props = defineProps([
  'icon',
  'image',
  'value',
  'max',
  'disableLines',
  'iconClass',
  'label',
  'sublabel',
]);

const positive: () => number = () => Math.max(0, Math.min(props.value / props.max, 1));
const amazing: () => number = () => Math.max(0, Math.min(props.value / props.max - 1, 1));
</script>

<template>
  <div
    class="relative inline-flex h-40 w-40 cursor-pointer flex-wrap justify-center overflow-hidden rounded-lg transition-all duration-200 hover:brightness-105 active:brightness-95"
    :class="amazing() > 0 ? 'bg-bg-amazing' : positive() > 0 ? 'bg-bg-positive' : 'bg-bg-neutral'"
  >
    <img v-if="amazing() > 0" src="/amazing.png" class="absolute top-2 left-2 h-4 w-4" />
    <div
      :class="props.max ? 'bottom-8' : props.sublabel ? 'bottom-6' : 'bottom-2'"
      class="font-fredoka font-outline-1 absolute left-0 z-10 w-40 text-center text-xl text-white select-none"
    >
      {{ label }}
    </div>
    <div
      v-if="props.sublabel"
      class="font-fredoka font-outline-1 absolute bottom-1 left-0 z-10 w-40 text-center text-xs text-white select-none"
    >
      {{ sublabel }}
    </div>
    <template v-if="props?.image">
      <directus-image :src="props.image" class="absolute top-0 left-0 h-40 w-40" />
    </template>
    <template v-if="props?.icon">
      <template v-if="typeof props?.icon === 'function'">
        <component
          :is="props.icon"
          class="absolute top-0 left-0 h-40 w-40"
          :class="props.iconClass"
        />
      </template>
      <template v-else-if="props?.icon?.length == 36">
        <directus-image :src="props.icon" class="-z1-10 absolute top-0 left-0 h-40 w-40" />
      </template>
      <template v-else>
        <div class="mt-4 text-6xl" :class="props.iconClass">{{ props.icon }}</div>
      </template>
    </template>
    <template v-if="props.max">
      <div
        class="bg-bg-empty border-border-empty absolute bottom-2 h-4 w-36 overflow-hidden rounded-2xl border-2"
      >
        <div
          class="bg-fill-positive absolute top-0 left-0 h-4 transition-all duration-200"
          :style="{ width: positive() * 100 + '%' }"
        ></div>
        <div
          class="bg-fill-amazing absolute top-0 left-0 h-4 transition-all duration-200"
          :style="{ width: amazing() * 100 + '%' }"
        ></div>
        <template v-if="!props.disableLines">
          <div
            v-for="i in props.max - 1"
            :key="i"
            class="bg-border-empty absolute top-0 h-4 w-0.5"
            :style="{ left: (100 / props.max) * i + '%' }"
          ></div>
        </template>
      </div>
    </template>
  </div>
</template>

<style scoped></style>
